import React from "react";
import SelectApiInput from "../../../../components/common/input/SelectApiInput";
import { Box, Container, MenuItem, Stack, Typography } from "@mui/material";
import { LuUser2 } from "react-icons/lu";
import { MOBILE_CONTAINER } from "../../../../utils/ui.constants";
import { useSelector } from "react-redux";
import { useOrderContext } from "../../OrderPage";

function Customer() {
  const { currentHd } = useSelector((state: any) => state.order);
  const { handleUpdateCurrentHd } = useOrderContext();

  return (
    <Box>
      <SelectApiInput
        useDrawer
        direction="column"
        apiCode="customer"
        defaultCondition={{ kh_yn: true }}
        searchFields={["ma_kh", "ten_kh"]}
        checkEqual={(value, option) => value?.ma_kh === option?.ten_kh}
        getOptionLabel={(option) => option.ten_kh}
        placeholderSearch="Tìm theo mã, tên khách hàng"
        renderDisplay={({ value, onClick }) => {
          return (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "background.paper",
              }}
            >
              <Container maxWidth={MOBILE_CONTAINER} sx={{ width: "100%" }}>
                <Stack
                  component={MenuItem}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%", height: "45px", padding: 0 }}
                  onClick={onClick}
                >
                  <LuUser2 size={20} />
                  <Typography
                    sx={{
                      flex: 1,
                      lineHeight: "45px",
                      color: "text.secondary",
                    }}
                  >
                    {!!value ? value?.ten_kh : "Chọn khách hàng"}
                  </Typography>
                </Stack>
              </Container>
            </Box>
          );
        }}
        value={
          currentHd?.ma_kh
            ? { ma_kh: currentHd?.ma_kh, ten_kh: currentHd?.ten_kh }
            : null
        }
        onChange={(val) =>
          handleUpdateCurrentHd({
            ma_kh: val?.ma_kh || "",
            ten_kh: val?.ten_kh || "",
          })
        }
      />
    </Box>
  );
}

export default Customer;
